import { MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';

import { BacklinkButton } from '../../../lib/Miscellaneous/BacklinkButton/BacklinkButton';
import Card from '../../../lib/Miscellaneous/Card';
import { Image } from '../../../styles';

import * as Styles from './ArbitrationClauses.styles';
import { arbitrationClausesLinks } from './constants';

export const ArbitrationClauses = () => {
  return (
    <div className={Styles.arbitrationClausesContainer}>
      <div className={Styles.top}>
        <BacklinkButton to={`/accounts/sign-application`} label='Return to My Account' />
        <img src={Image.Logo} alt='My IPO' className={Styles.logo} />
      </div>
      <div className={Styles.container}>
        <MTypography variant='h3' weight='semibold' color={Color.Brand6} className={Spacing.mb24}>
          Arbitration Clauses
        </MTypography>
        <Card>
          <div className={Styles.certificationMain}>
            {arbitrationClausesLinks.map(item => (
              <MTypography
                key={`${item.label}_key`}
                variant='body1'
                color={Color.Brand6}
                className={Styles.certificationLink}>
                <a className={Styles.linkStyle} href={item.url} target='_blank' rel='noreferrer'>
                  {item.label}
                </a>
              </MTypography>
            ))}
            <MTypography variant='body1' className={Styles.arbitrationThanks}>
              Apex Arbitration clause found on page 3 and 4 of Apex Clearing Corporation Customer Agreement & Privacy
              Policy and My IPO{' '}
              <a href='/static/docs/Privacy_Policy_Revision_2025.pdf' target='_blank' rel='noreferrer'>
                Privacy Policy{' '}
              </a>
              .
            </MTypography>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ArbitrationClauses;
